<template>
  <div class="table-page-wrapper">
    <div class="search-wrapper">
      <el-input v-model="tableParams.materialName" clearable size="medium" placeholder="输入素材名称" />
      <el-select v-model="tableParams.status" clearable placeholder="请选择状态" size="medium">
        <el-option label="禁用" :value="0"></el-option>
        <el-option label="启用" :value="1"></el-option>
      </el-select>
      <el-select v-model="tableParams.materialType" clearable placeholder="请选择素材类型" size="medium">
        <el-option label="图片" :value="1"></el-option>
        <el-option label="视频" :value="2"></el-option>
      </el-select>
      <emboss-button @click="toQuery" size="medium" color="#2C7A14">🔍</emboss-button>
    </div>

    <div class="table-wrapper">
      <div class="table__operation" style="padding-bottom: 10px; display: flex; justify-content: space-between;">
        <div>
          <el-button @click="add" type="primary" size="small">新增</el-button>
          <el-button @click="openCopyDialog" type="warning" size="small" style="margin-left: 10px;">从其他广告位复制</el-button>
        </div>
        <el-button @click="goBack" size="large" type="success">返回</el-button>
      </div>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh"
                highlight-current-row size="small" class="js-table"
                style="width: 100%">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="materialId" label="素材ID" align="center" width="80"></el-table-column>
        <el-table-column prop="materialName" label="素材名称" align="center" min-width="150"></el-table-column>
        <el-table-column prop="materialType" label="素材类型" align="center" width="80">
          <template v-slot="scope">
            <el-tag v-if="scope.row.materialType === 1" type="success">图片</el-tag>
            <el-tag v-else-if="scope.row.materialType === 2" type="warning">视频</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="广告标题" align="center" min-width="150"></el-table-column>
        <el-table-column label="素材预览" align="center" width="120">
          <template v-slot="scope">
            <el-image
              v-if="scope.row.imageUrl || scope.row.videoCoverUrl"
              :src="scope.row.imageUrl || scope.row.videoCoverUrl"
              :preview-src-list="[scope.row.imageUrl || scope.row.videoCoverUrl]"
              fit="cover"
              style="width: 60px; height: 60px; cursor: pointer;"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="width" label="尺寸" align="center" width="100">
          <template v-slot="scope">
            {{ scope.row.width }}x{{ scope.row.height }}
          </template>
        </el-table-column>
        <el-table-column prop="actionType" label="交互类型" align="center" width="100">
          <template v-slot="scope">
            {{ actionTypeMap[scope.row.actionType] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="ecpm" label="出价(分)" align="center" width="100">
          <template v-slot="scope">
            {{ scope.row.ecpm ? scope.row.ecpm + '分' : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="权重" align="center" width="80"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80">
          <template v-slot="scope">
            <el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1" :inactive-value="0"
                       @change="upStatus(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="150"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="300">
          <template v-slot="scope">
            <el-button @click="update(scope.row)" type="success" size="mini">编辑</el-button>
            <el-button @click="copy(scope.row)" type="primary" size="mini">复制</el-button>
            <el-button @click="del(scope.row.materialId)" type="danger" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
                     :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
                     background layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
    </div>

    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="900px" top="5vh">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" class="material-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="素材名称" prop="materialName">
              <el-input v-model="form.materialName" placeholder="请输入素材名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="素材类型" prop="materialType">
              <el-select v-model="form.materialType" placeholder="请选择素材类型" style="width: 100%">
                <el-option label="图片" :value="1"></el-option>
                <el-option label="视频" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="广告ID" prop="adId">
              <el-input v-model="form.adId" placeholder="外部广告唯一标识"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交互类型" prop="actionType">
              <el-select v-model="form.actionType" placeholder="请选择交互类型" style="width: 100%">
                <el-option label="无动作" :value="0"></el-option>
                <el-option label="打开落地页" :value="1"></el-option>
                <el-option label="下载" :value="2"></el-option>
                <el-option label="吊起" :value="3"></el-option>
                <el-option label="微信小程序" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="广告标题" prop="title">
              <el-input v-model="form.title" placeholder="请输入广告标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="按钮文字" prop="buttonText">
              <el-input v-model="form.buttonText" placeholder="如：立即下载、立即打开"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="广告描述" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="2" placeholder="请输入广告描述"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="素材宽度" prop="width">
              <el-input-number v-model="form.width" :min="1" placeholder="像素" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="素材高度" prop="height">
              <el-input-number v-model="form.height" :min="1" placeholder="像素" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="出价(ECPM)" prop="ecpm">
              <el-input-number v-model="form.ecpm" :min="0" placeholder="单位：分" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="权重" prop="weight">
              <el-input-number v-model="form.weight" :min="0" placeholder="数值越大优先级越高" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="每日曝光上限" prop="dailyImpLimit">
              <el-input-number v-model="form.dailyImpLimit" :min="0" placeholder="0表示无限制" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每日点击上限" prop="dailyClickLimit">
              <el-input-number v-model="form.dailyClickLimit" :min="0" placeholder="0表示无限制" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="视频时长" prop="videoDuration" v-if="form.materialType === 2">
              <el-input-number v-model="form.videoDuration" :min="0" placeholder="单位：秒" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 图片上传 -->
        <el-form-item label="图片素材" prop="imageUrl" v-if="form.materialType === 1">
          <el-upload
            class="upload-drag"
            drag
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleImageSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeImageUpload"
            :file-list="imageFileList"
            accept="image/*"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              将文件拖到此处，或 <em>点击上传</em>
            </div>
            <template #tip>
              <div class="el-upload__tip">
                支持jpg/png/gif格式，多张图片用英文逗号分隔
              </div>
            </template>
          </el-upload>
          <el-input v-model="form.imageUrl" placeholder="图片URL，多张用英文逗号分隔" style="margin-top: 10px;"></el-input>
          <div v-if="form.imageUrl" class="preview-list">
            <el-image
              v-for="(url, index) in imageUrlList"
              :key="index"
              :src="url"
              :preview-src-list="imageUrlList"
              fit="cover"
              class="preview-img"
            />
          </div>
        </el-form-item>

        <!-- 视频上传 -->
        <template v-if="form.materialType === 2">
          <el-form-item label="视频素材" prop="videoUrl">
            <el-upload
              class="upload-drag"
              drag
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleVideoSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeVideoUpload"
              :file-list="videoFileList"
              accept="video/*"
            >
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">
                将视频拖到此处，或 <em>点击上传</em>
              </div>
              <template #tip>
                <div class="el-upload__tip">
                  支持mp4/mov/avi格式
                </div>
              </template>
            </el-upload>
            <el-input v-model="form.videoUrl" placeholder="视频URL" style="margin-top: 10px;"></el-input>
          </el-form-item>

          <el-form-item label="视频封面" prop="videoCoverUrl">
            <el-upload
              class="upload-drag"
              drag
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleVideoCoverSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeImageUpload"
              accept="image/*"
            >
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">
                将封面图拖到此处，或 <em>点击上传</em>
              </div>
            </el-upload>
            <el-input v-model="form.videoCoverUrl" placeholder="视频封面URL" style="margin-top: 10px;"></el-input>
            <el-image
              v-if="form.videoCoverUrl"
              :src="form.videoCoverUrl"
              :preview-src-list="[form.videoCoverUrl]"
              fit="cover"
              style="width: 100px; height: 100px; margin-top: 10px;"
            />
          </el-form-item>
        </template>

        <el-form-item label="Logo图片" prop="logoUrl">
          <el-upload
            class="upload-drag"
            drag
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleLogoSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeImageUpload"
            accept="image/*"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              将Logo拖到此处，或 <em>点击上传</em>
            </div>
          </el-upload>
          <el-input v-model="form.logoUrl" placeholder="Logo URL" style="margin-top: 10px;"></el-input>
          <el-image
            v-if="form.logoUrl"
            :src="form.logoUrl"
            :preview-src-list="[form.logoUrl]"
            fit="cover"
            style="width: 60px; height: 60px; margin-top: 10px;"
          />
        </el-form-item>

        <el-form-item label="落地页URL" prop="landingUrl" >
          <el-input v-model="form.landingUrl" placeholder="请输入落地页URL"></el-input>
        </el-form-item>

        <el-form-item label="DeepLink" prop="deepLink" >
          <el-input v-model="form.deepLink" placeholder="如：tbopen://..."></el-input>
        </el-form-item>

        <el-form-item label="下载链接" prop="downloadUrl" v-if="form.actionType === 2">
          <el-input v-model="form.downloadUrl" placeholder="应用下载类广告使用"></el-input>
        </el-form-item>

        <el-form-item label="应用商店链接" prop="marketUrl">
          <el-input v-model="form.marketUrl" placeholder="应用商店直投链接"></el-input>
        </el-form-item>

        <el-form-item label="Universal Link" prop="universalLink">
          <el-input v-model="form.universalLink" placeholder="iOS Universal Link"></el-input>
        </el-form-item>

        <!-- 微信小程序 -->
        <template v-if="form.actionType === 4">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="小程序原始ID" prop="miniProgramId">
                <el-input v-model="form.miniProgramId" placeholder="请输入小程序原始ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小程序路径" prop="miniProgramPath">
                <el-input v-model="form.miniProgramPath" placeholder="请输入小程序路径"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- 应用信息 -->
        <template v-if="form.actionType === 2">
          <el-divider content-position="left">应用信息（下载类广告）</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="应用名称" prop="appName">
                <el-input v-model="form.appName" placeholder="请输入应用名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应用包名" prop="appPkg">
                <el-input v-model="form.appPkg" placeholder="请输入应用包名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="应用版本" prop="appVersion">
                <el-input v-model="form.appVersion" placeholder="请输入应用版本"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开发者名称" prop="developerName">
                <el-input v-model="form.developerName" placeholder="请输入开发者名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="应用描述" prop="appDescription">
            <el-input v-model="form.appDescription" type="textarea" :rows="2" placeholder="请输入应用描述"></el-input>
          </el-form-item>

          <el-form-item label="应用图标" prop="appIconUrl">
            <el-upload
              class="upload-drag"
              drag
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleAppIconSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeImageUpload"
              accept="image/*"
            >
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">
                将图标拖到此处，或 <em>点击上传</em>
              </div>
            </el-upload>
            <el-input v-model="form.appIconUrl" placeholder="应用图标URL" style="margin-top: 10px;"></el-input>
            <el-image
              v-if="form.appIconUrl"
              :src="form.appIconUrl"
              :preview-src-list="[form.appIconUrl]"
              fit="cover"
              style="width: 60px; height: 60px; margin-top: 10px;"
            />
          </el-form-item>

          <el-form-item label="隐私政策URL" prop="privacyPolicyUrl">
            <el-input v-model="form.privacyPolicyUrl" placeholder="请输入隐私政策URL"></el-input>
          </el-form-item>

          <el-form-item label="权限说明URL" prop="permissionUrl">
            <el-input v-model="form.permissionUrl" placeholder="请输入权限说明URL"></el-input>
          </el-form-item>

          <el-form-item label="应用介绍URL" prop="introUrl">
            <el-input v-model="form.introUrl" placeholder="请输入应用介绍URL"></el-input>
          </el-form-item>
        </template>

        <el-divider content-position="left">监测链接</el-divider>
        <el-form-item label="曝光监测链接" prop="impTrackingUrl">
          <el-input v-model="form.impTrackingUrl" type="textarea" :rows="2" placeholder="多个链接用英文逗号分隔"></el-input>
        </el-form-item>

        <el-form-item label="点击监测链接" prop="clickTrackingUrl">
          <el-input v-model="form.clickTrackingUrl" type="textarea" :rows="2" placeholder="多个链接用英文逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="广告主" prop="ocpxCampaignId">
          <el-select v-model="form.ocpxCampaignId" placeholder="请选择广告主" size="medium" filterable style="width: 100%;" @change="handleAdvertiserChange">
            <el-option
              v-for="item in advertiserList"
              :key="item.id"
              :label="item.advertiserName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>



        <el-form-item label="转化任务" prop="ocpxTaskId">
          <el-select v-model="form.ocpxTaskId" placeholder="请选择转化任务" size="medium" filterable style="width: 100%;">
            <el-option
              v-for="item in taskList"
              :key="item.id"
              :label="item.taskName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>


        <el-form-item label="扩展信息" prop="extInfo">
          <el-input v-model="form.extInfo" type="textarea" :rows="3" placeholder="JSON格式，存储额外配置"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 复制创意对话框 -->
    <el-dialog :title="copyDialogTitle" v-model="copyDialogVisible" width="1000px" top="5vh">
      <div class="search-wrapper" style="padding: 0 0 15px 0;">
        <el-input v-model="copyTableParams.materialName" clearable size="medium" placeholder="输入素材名称" />
        <el-input v-model="copyTableParams.dspSlotId" clearable size="medium" placeholder="输入广告位ID" />
          <emboss-button @click="searchCopyList" size="medium" color="#2C7A14">🔍</emboss-button>
      </div>
      <el-table v-loading="copyTableLoading" :data="copyTableData" height="50vh"
                highlight-current-row size="small"
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="materialId" label="素材ID" align="center" width="80"></el-table-column>
        <el-table-column prop="materialName" label="素材名称" align="center" min-width="150"></el-table-column>
        <el-table-column prop="dspSlotId" label="广告位ID" align="center" width="100"></el-table-column>
        <el-table-column prop="materialType" label="素材类型" align="center" width="80">
          <template v-slot="scope">
            <el-tag v-if="scope.row.materialType === 1" type="success">图片</el-tag>
            <el-tag v-else-if="scope.row.materialType === 2" type="warning">视频</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="素材预览" align="center" width="120">
          <template v-slot="scope">
            <el-image
              v-if="scope.row.imageUrl || scope.row.videoCoverUrl"
              :src="scope.row.imageUrl || scope.row.videoCoverUrl"
              :preview-src-list="[scope.row.imageUrl || scope.row.videoCoverUrl]"
              fit="cover"
              style="width: 60px; height: 60px; cursor: pointer;"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="width" label="尺寸" align="center" width="100">
          <template v-slot="scope">
            {{ scope.row.width }}x{{ scope.row.height }}
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="copyDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitCopy" :disabled="selectedMaterials.length === 0">复 制</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { fetchMaterialList, addMaterial, updateMaterial, deleteMaterial, updateMaterialStatus, copyMaterial } from '@/api/manage/dsp/material'
import initTableMixin from '@/mixins/initTable'
import { UploadFilled } from '@element-plus/icons-vue'
import EmbossButton from '@/components/EmbossButton'
import { mapGetters } from 'vuex'
import { getConversionTaskListByAdvertiserId } from '@/api/ocpx/conversionTask'
import { getEnabledAdvertiserList } from '@/api/ocpx/advertiser'

export default {
  name: 'ManageDspAdMaterial',
  components: {
    UploadFilled,
    EmbossButton
  },
  mixins: [initTableMixin],
  data () {
    return {
      dspSlotId: null,
      dialogVisible: false,
      dialogTitle: '新增素材',
      copyDialogVisible: false,
      copyDialogTitle: '从其他广告位复制创意',
      copyTableData: [],
      copyTableLoading: false,
      copyTableParams: {
        materialName: null,
        dspSlotId: null
      },
      selectedMaterials: [],
      actionTypeMap: { 0: '无动作', 1: '打开落地页', 2: '下载', 3: '吊起', 4: '微信小程序' },
      uploadUrl: process.env.VUE_APP_BASE_API + '/common/upload/image',
      uploadHeaders: {},
      imageFileList: [],
      videoFileList: [],
      taskList: [],
      advertiserList: [],
      form: {
        materialId: null,
        dspSlotId: null,
        materialName: '',
        adId: '',
        ocpxCampaignId: undefined,
        ocpxTaskId: undefined,
        actionType: 1,
        landingUrl: '',
        deepLink: '',
        downloadUrl: '',
        marketUrl: '',
        universalLink: '',
        materialType: 1,
        imageUrl: '',
        videoUrl: '',
        videoCoverUrl: '',
        width: null,
        height: null,
        videoDuration: null,
        title: '',
        description: '',
        buttonText: '',
        ecpm: null,
        impTrackingUrl: '',
        clickTrackingUrl: '',
        status: 1,
        weight: 0,
        dailyImpLimit: 0,
        dailyClickLimit: 0,
        extInfo: '',
        miniProgramId: '',
        miniProgramPath: '',
        logoUrl: '',
        appPkg: '',
        appName: '',
        appDescription: '',
        appIconUrl: '',
        appVersion: '',
        developerName: '',
        privacyPolicyUrl: '',
        permissionUrl: '',
        introUrl: ''
      },
      rules: {
        materialName: [{ required: true, message: '请输入素材名称', trigger: 'blur' }],
        materialType: [{ required: true, message: '请选择素材类型', trigger: 'change' }],
        actionType: [{ required: true, message: '请选择交互类型', trigger: 'change' }],
        width: [{ required: true, message: '请输入宽度', trigger: 'blur' }],
        height: [{ required: true, message: '请输入高度', trigger: 'blur' }],
        title: [{ required: true, message: '请输入广告标题', trigger: 'blur' }],
        ecpm: [
          { required: true, message: '请输入出价', trigger: 'blur' },
          { type: 'number', max: 2000, message: '出价不得大于2000', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['access_token']),
    imageUrlList () {
      return this.form.imageUrl ? this.form.imageUrl.split(',').filter(url => url.trim()) : []
    }
  },
  created () {
    this.dspSlotId = this.$route.query.dspSlotId
    if (!this.dspSlotId) {
      this.$message.error('缺少广告位ID参数')
      this.goBack()
      return
    }
    this.uploadHeaders = {
      Authorization: 'Bearer ' + this.access_token
    }
  },
  mounted () {
    this.init()
    this.loadTaskList()
    this.loadAdvertiserList()
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/dspSelfMaterial/list'
      this.tableParams.dspSlotId = this.dspSlotId
      return true
    },
    goBack () {
      this.$router.push('/dsp/user/manage/dsp/ad')
    },
    add (rowData = null) {
      this.dialogTitle = '新增素材'
      this.resetForm()
      this.form.dspSlotId = this.dspSlotId
      if (rowData) {
        this.form = { ...this.form, ...rowData }
        this.form.materialId = null
      }
      this.dialogVisible = true
    },
    copy (row) {
      const copyData = JSON.parse(JSON.stringify(row))
      copyData.materialName = copyData.materialName + '_复制'
      this.add(copyData)
    },
    openCopyDialog () {
      this.copyDialogVisible = true
      this.copyTableParams.materialName = ''
      this.copyTableParams.dspSlotId = ''
      this.copyTableData = []
      this.selectedMaterials = []
    },
    searchCopyList () {
      this.copyTableLoading = true
      const params = {
        ...this.copyTableParams,
        pageNum: 1,
        pageSize: 100
      }
      fetchMaterialList(params).then(res => {
        if (res.code === 200) {
          this.copyTableData = res.data.records || []
        }
        this.copyTableLoading = false
      }).catch(() => {
        this.copyTableLoading = false
      })
    },
    handleSelectionChange (val) {
      this.selectedMaterials = val
    },
    submitCopy () {
      const promises = this.selectedMaterials.map(item => {
        return copyMaterial(item.materialId, this.dspSlotId)
      })
      Promise.all(promises).then(() => {
        this.$message.success('复制成功')
        this.copyDialogVisible = false
        this.toQuery()
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
    update (row) {
      this.dialogTitle = '编辑素材'
      this.form = { ...this.form, ...row }
      // 如果有广告主 ID，加载对应的转化任务列表
      if (row.ocpxCampaignId) {
        getConversionTaskListByAdvertiserId(row.ocpxCampaignId).then(res => {
          if (res.code === 200) {
            this.taskList = res.data || []
          }
        })
      }
      this.dialogVisible = true
    },
    resetForm () {
      this.form = {
        materialId: null,
        dspSlotId: this.dspSlotId,
        materialName: '',
        adId: '',
        actionType: 1,
        landingUrl: '',
        deepLink: '',
        downloadUrl: '',
        marketUrl: '',
        universalLink: '',
        materialType: 1,
        imageUrl: '',
        videoUrl: '',
        videoCoverUrl: '',
        width: null,
        height: null,
        videoDuration: null,
        title: '',
        description: '',
        buttonText: '',
        ecpm: null,
        impTrackingUrl: '',
        clickTrackingUrl: '',
        status: 1,
        weight: 0,
        dailyImpLimit: 0,
        dailyClickLimit: 0,
        extInfo: '',
        miniProgramId: '',
        miniProgramPath: '',
        logoUrl: '',
        appPkg: '',
        appName: '',
        appDescription: '',
        appIconUrl: '',
        appVersion: '',
        developerName: '',
        privacyPolicyUrl: '',
        permissionUrl: '',
        introUrl: ''
      }
      this.imageFileList = []
      this.videoFileList = []
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    submitForm () {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.form.dspSlotId = this.dspSlotId
          const api = this.form.materialId ? updateMaterial : addMaterial
          api(this.form).then(res => {
            if (res.code === 200) {
              this.$message.success(this.form.materialId ? '修改成功' : '新增成功')
              this.dialogVisible = false
              this.toQuery()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          })
        }
      })
    },
    del (id) {
      this.$confirm('确认删除该素材?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMaterial([id]).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.toQuery()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        })
      })
    },
    upStatus (row) {
      updateMaterialStatus(row.materialId, row.status).then(res => {
        if (res.code === 200) {
          this.$message.success('状态更新成功')
        } else {
          this.$message.error(res.msg || '状态更新失败')
        }
      })
    },
    // 上传相关方法
    beforeImageUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('请上传图片文件')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片大小不能超过10MB')
        return false
      }
      return true
    },
    beforeVideoUpload (file) {
      const isVideo = file.type.startsWith('video/')
      if (!isVideo) {
        this.$message.error('请上传视频文件')
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('视频大小不能超过100MB')
        return false
      }
      return true
    },
    handleImageSuccess (res) {
      if (res.code === 200) {
        const url = Array.isArray(res.data) ? res.data[0] : res.data.url
        if (this.form.imageUrl) {
          this.form.imageUrl += ',' + url
        } else {
          this.form.imageUrl = url
        }
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    handleVideoSuccess (res) {
      if (res.code === 200) {
        this.form.videoUrl = Array.isArray(res.data) ? res.data[0] : res.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    handleVideoCoverSuccess (res) {
      if (res.code === 200) {
        this.form.videoCoverUrl = Array.isArray(res.data) ? res.data[0] : res.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    handleLogoSuccess (res) {
      if (res.code === 200) {
        this.form.logoUrl = Array.isArray(res.data) ? res.data[0] : res.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    handleAppIconSuccess (res) {
      if (res.code === 200) {
        this.form.appIconUrl = Array.isArray(res.data) ? res.data[0] : res.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    handleUploadError () {
      this.$message.error('上传失败')
    },
    loadTaskList () {
      getConversionTaskListByAdvertiserId(1).then(res => {
        if (res.code === 200) {
          this.taskList = res.data || []
        }
      })
    },
    loadAdvertiserList () {
      getEnabledAdvertiserList().then(res => {
        if (res.code === 200) {
          this.advertiserList = res.data || []
        }
      })
    },
    handleAdvertiserChange (advertiserId) {
      // 当广告主改变时，清空转化任务选择
      this.form.ocpxTaskId = undefined
      // 重新加载对应的转化任务列表
      if (advertiserId) {
        getConversionTaskListByAdvertiserId(advertiserId).then(res => {
          if (res.code === 200) {
            this.taskList = res.data || []
          }
        })
      } else {
        this.taskList = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: $--common-card-color;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: $--common-card-color;
}

.el-pagination {
  text-align: right;
}

.material-form {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}

.upload-drag {
  width: 100%;

  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 120px;
  }

  ::v-deep .el-icon--upload {
    font-size: 40px;
    margin-top: 10px;
  }
}

.preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.preview-img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
